// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../node_modules/css-loader/dist/cjs.js??ref--7-oneOf-0-1!../../../../../../node_modules/postcss-loader/src/index.js??ref--7-oneOf-0-2!../../../../../../node_modules/sass-loader/dist/cjs.js??ref--7-oneOf-0-3!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--7-oneOf-0-4!./authorization-form-error.scss?module");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("2119ddef", content, true, {"sourceMap":false});